import './TopBarAlert.scss';

import classnames from 'classnames';
import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Suspense, lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import { getData, hideAlert } from 'store/parts/alert/actions';

const Content = lazy(() => import('./components/Content'));

const propTypes = {
  className: PropTypes.string,
  // store
  visible: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  getData: PropTypes.func.isRequired,
  hideAlert: PropTypes.func.isRequired
};

const TopBarAlert = ({
  className,
  visible,
  loading,
  data,
  errorMessage,
  getData,
  hideAlert
}) => {
  const MAX_EXCERPT_LENGTH = 50;

  useEffect(() => {
    let timeout;

    if (visible && !loading && !errorMessage && !data) {
      timeout = setTimeout(() => {
        getData();
      }, 7000);
    }

    return () => clearTimeout(timeout);
  }, [visible, loading, data, errorMessage, getData]);

  const { title, content, link } = data || {};

  return !visible || !title ? null : (
    <div className={classnames('top-bar-alert', className)}>
      <button
        onClick={() => hideAlert()}
        type="button"
        className="close"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
      <span className="text container">
        <LinkNav to={link || getPageLink('page-note')}>
          <Suspense fallback={null}>
            <Content
              maxLength={MAX_EXCERPT_LENGTH}
              title={title}
              content={content}
            />
          </Suspense>
        </LinkNav>
      </span>
    </div>
  );
};

TopBarAlert.propTypes = propTypes;

const mapStateToProps = state => ({
  visible: _get(state, 'alert.visible'),
  loading: _get(state, 'alert.loading'),
  data: _get(state, 'alert.data'),
  errorMessage: _get(state, 'alert.errorMessage')
});

export default connect(mapStateToProps, { getData, hideAlert })(TopBarAlert);
